
import { defineComponent, PropType } from 'vue'

// types
import { ReportT } from '@/core/types/kpi.types'

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<ReportT>,
            required: true,
        },
    },
})
